// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chat{margin-bottom:32px}.chat.chat--collapsed .chat__body{display:none}.chat>header{margin-bottom:24px}.chat>header .chat__actions{float:right}.chat>header .chat__actions .chat__actions--expand{font-size:32px;cursor:pointer;border-radius:16px}.chat>header .chat__actions .chat__actions--expand:hover{background:rgba(0,10,30,.04)}.chat>header .chat__foreign-typ-ref{color:#fa0019}.chat>header .chat__description{margin-top:12px}", ""]);
// Exports
module.exports = exports;
